<template>
    <div class='goodsnumscon'>
          <div class="goodsnumscon-op" @click="dec">-</div>
          <div class="goodsnumscon-digit"><input class='goodsnumscon-digit' :value='fahuonums' @blur='updatenums'/></div>
          <div class="goodsnumscon-op plus" @click="add">+</div>
    </div>
</template>
<script>
export default {
  name: 'FahuoNums',
  props: {
    item: Object
  },
  computed:{
    fahuonums(){
        return this.$store.getters.fahuoitemnums(this.item.id,this.$store.state.fahuo.clicked)
    }
  },
  methods:{
      add(){
        if(this.fahuonums<this.item.stock){
          this.$store.commit('ADD_TO_FAHUO',{goodsItem:this.item})
        }
      },
      dec(){
         if(this.fahuonums>=1){
             this.$store.commit('DEL_FROM_FAHUO',{goodsItem:this.item})
         }
      },
      updatenums(e){
         let nums=parseInt(e.target.value)
         if(nums>0 && nums<=this.item.stock){
            this.$store.commit('UPDATE_FHNUMS',{goodsid:this.item.id,goodsnums:nums,goodsitem:this.item})
         }else if(nums>=this.item.stock){
            this.$store.commit('UPDATE_FHNUMS',{goodsid:this.item.id,goodsnums:this.item.stock,goodsitem:this.item})
         }else if(nums<=0){
            this.$store.commit('UPDATE_FHNUMS',{goodsid:this.item.id,goodsnums:0,goodsitem:this.item})
         }
      }
  }
}
</script>
<style scoped>
.goodsnumscon{display: flex;}
.goodsnumscon-op{background-color: #f7f7f7;color:#7d7d7d;width:0.8rem;height:0.8rem;display: flex;justify-content: center;align-items: center;font-size:0.8rem;margin: 0 0.2rem;}
.plus{color:#d88045}
.goodsnumscon-digit{background-color: #f7f7f7;color:#7d7d7d;width:1.6rem;height:0.8rem;display: flex;justify-content: center;align-items: center;font-size:0.5rem;text-align: center;}
</style>


